<template>

    <v-container>

        <v-dialog v-model="estadoModal" persistent fullscreen>
            <v-card v-on:keyup.enter="eventDiapositiva('next')" v-on:keyup.down="eventDiapositiva('next')"
                v-on:keyup.up="eventDiapositiva('back')">

                <v-card-text>
                    <v-row class="d-flex justify-end py-0">
                        <v-btn fab dark x-small class="btn_editar white--text" v-if="mostrarBotonParticipacion == true"
                            @click="mostrarParticipacion"><v-icon dark>fa-users</v-icon></v-btn>
                        <v-btn fab dark x-small class="mx-2 btn_block_style2" @click="fullWindows = !fullWindows">
                            <v-icon dark :disabled="fullWindows"> fa-desktop</v-icon>
                        </v-btn>
                        <v-btn fab dark x-small class="btn_style3" @click="cerrarModal"><v-icon
                                dark>fa-times</v-icon></v-btn>
                    </v-row>

                    <v-row>

                        <template v-if="!fullWindows">

                            <v-col cols="2">

                                <v-row wrap style="max-height: 80vh" class="overflow-y-auto" id="sx">

                                    <v-col cols="12" v-for="(item, index) of data" :key="index">

                                        <v-card @click="loadDiapositiva(item, index)" class="cardMiniatura"
                                            :class="item.id == idDiapositiva.id ? 'classP' : ''" :id="index + 1"
                                            :ref="item.id">



                                            <div>
                                                <v-avatar color="indigo" size="26" class="avatar_num">
                                                    <span class="white--text headline">{{ index + 1 }}</span>
                                                </v-avatar>

                                                <div v-if="item.titulo != null" class="contMiniatura text-center">
                                                    <span v-html="item.titulo.replace(/(<([^>]+)>)/gi, '')"
                                                        class="font-weight-black mx-2 pl-5"
                                                        style="font-size:12px"></span>

                                                    <!--
                                                    --  <span class="font-weight-black mx-2" style="font-size:12px">{{item.titulo | filtroCaracteres3}}</span>
                                                    --  <span v-html="item.titulo.substr(0,35).replace(/(<([^>]+)>)/gi, '')" class="font-weight-black mx-2" style="font-size:12px"></span>
                                                    -->
                                                </div>

                                            </div>

                                            {{ item }}
                                            <span v-if="item.miniatura_archivo == null || item.miniatura_archivo == ''">

                                                <v-img src="@/assets/iconos/PU.svg" v-if="item.tipo === 'PU'"
                                                    class="white--text align-end imagen"></v-img>
                                                <v-img src="@/assets/iconos/PM.svg" v-if="item.tipo === 'PM'"
                                                    class="white--text align-end imagen"></v-img>
                                                <v-img src="@/assets/iconos/VF.svg" v-if="item.tipo === 'PV'"
                                                    class="white--text align-end imagen"></v-img>

                                                <v-img src="@/assets/iconos/1-COL.jpg" v-if="item.tipo === 'C1'"
                                                    class="white--text align-end imagen"></v-img>
                                                <v-img src="@/assets/iconos/2-COL.jpg" v-if="item.tipo === 'C2'"
                                                    class="white--text align-end imagen"></v-img>
                                                <v-img src="@/assets/iconos/3-COL.jpg" v-if="item.tipo === 'C3'"
                                                    class="white--text align-end imagen"></v-img>
                                                <v-img src="@/assets/iconos/4-COL.jpg" v-if="item.tipo === 'C4'"
                                                    class="white--text align-end imagen"></v-img>

                                            </span>

                                            <span v-else>
                                                <v-img :src="rutaServe + item.miniatura_ruta + item.miniatura_archivo"
                                                    class="white--text align-end imagen"></v-img>
                                                <!--
                                                    <v-img  :src="rutaServe+item.miniatura_ruta+item.miniatura_archivo" max-height="200" class="white--text align-end imagen"></v-img>
                                                -->
                                            </span>

                                        </v-card>

                                    </v-col>

                                </v-row>

                            </v-col>

                        </template>
                        <!-- end side -->

                        <template v-if="fullWindows">
                            <v-col cols="12" class="pa-0 contenido_lienzo" id="contenedorScreen" ref="contenedorScreen">

                                <transition :name="transitionName">
                                    <component :is="nombreComp" :presentacion='diapost' :preguntas="pregunta"
                                        :respuestaVerdadera="rv" :respuestaUnica="ru" :respuestas="rm"
                                        @comprobar="validarRespuesta" :opciones="opcs" :validar="valid"
                                        :screen="screen">
                                    </component>
                                </transition>

                            </v-col>

                        </template>

                        <template v-else>
                            <v-col cols="10" class="pa-0 contenido_lienzo" id="contenedorScreen" ref="contenedorScreen">

                                <transition :name="transitionName">
                                    <component :is="nombreComp" :presentacion='diapost' :preguntas="pregunta"
                                        :respuestaVerdadera="rv" :respuestaUnica="ru" :respuestas="rm"
                                        @comprobar="validarRespuesta" :opciones="opcs" :validar="valid"
                                        :screen="screen">
                                    </component>
                                </transition>

                            </v-col>
                        </template>




                    </v-row>

                    <v-row v-if="parametros.miniatura">
                        <v-col>
                            <v-btn class="btn_block_style2" @click="loadScreen('contenedorScreen')"
                                :disabled="screen">Generar CAPTURA DE
                                PANTALLA</v-btn>
                        </v-col>
                    </v-row>

                </v-card-text>

            </v-card>
            <span v-if="test">

                <code>ID Diapositiva :{{ idDiapositiva }}</code>
                <br>
                <code>Diapositiva :{{ diapost }}</code>
                <br>
                <code> Json IN :{{ jsonIN }}</code>
                <br>
                <code>Json OUT :{{ jsonOUT }}</code>
                <br>
                <code>Json END :{{ jsonEND }}</code>
                <br>
                <code> parametros : {{ parametros }}</code>
                <br>

            </span>
        </v-dialog>


        <v-dialog v-model="screen" persistent scrollable max-width="60%">
            <v-card>
                <v-card-title class="btn_otro">
                    <v-row class="d-flex justify-space-between py-0">
                        Referencia de creación de miniatura
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" v-if="parametros.miniatura">
                            <v-row justify="center">

                                <v-col cols="12" v-if="imgTemp">
                                    <v-img :src="imgTemp" id="imgTemp" max-width="300" max-height="300"
                                        class="mx-auto"></v-img>
                                </v-col>

                                <v-col cols="12" v-else class="d-flex justify-center">
                                    <v-progress-circular :size="100" :width="10" indeterminate color="primary"> {{ value
                                    }}
                                    </v-progress-circular>
                                </v-col>

                            </v-row>
                        </v-col>

                    </v-row>

                </v-card-text>

                <v-divider></v-divider>


            </v-card>

        </v-dialog>


    </v-container>

</template>


<script>
// REVISAR PARA EL LUNES
// https://www.desarrollolibre.net/blog/html/recortes-de-imagenes-con-html5-y-jquery#.YE1IXJ1KiUk
// https://programadorwebvalencia.com/javascript-recortar-y-previsualizar-imagen/

// https://stackoverflow.com/questions/28538913/crop-an-image-displayed-in-a-canvas
// https://www.desarrollolibre.net/blog/html/recortes-de-imagenes-con-html5-y-jquery#.YEvmkmhKiUk  // crroping
// https://developer.mozilla.org/es/docs/Web/API/CanvasRenderingContext2D/drawImage
// ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
// https://www.youtube.com/watch?v=LrN3lbxuZLw



import axios, { API_URL } from "@/helpers/axios";

import { mapMutations } from 'vuex';
// import Cropper from 'cropperjs';
// import 'cropperjs/dist/cropper.css';
//  https://github.com/fengyuanchen/cropperjs#cropperjs // libreria usada

import VistaCol01 from '@/views/Manager/CreadorContenido/componentes/vistas/VistaCol01.vue';
import VistaCol02 from '@/views/Manager/CreadorContenido/componentes/vistas/VistaCol02.vue';
import VistaCol03 from '@/views/Manager/CreadorContenido/componentes/vistas/VistaCol03.vue';
import VistaPreg from '@/views/Manager/CreadorContenido/componentes/vistas/VistaPre1.vue';

import html2canvas from 'html2canvas';
import canvas2Image from 'canvas2image-2';
import Template from '../template/template.vue';

// Ejemplo de animiaciones
// https://www.npmjs.com/package/vue2-animate#rotate
export default {
    name: 'VisorContenido',

    props: ['estadoModal', 'parametros', 'evento', 'mostrarBotonParticipacion'],
    //    props:['data'],
    components: {
        VistaCol01,
        VistaCol02,
        VistaCol03,
        VistaPreg,
        Template
    },

    data() {
        return {

            data: [],
            test: false,
            // online rutaServe:`${window.location.protocol}//${window.location.host}/archivo/obtenerArchivo/` ,
            // offline rutaServe: `http://localhost:5000/archivo/obtenerArchivo/` ,
            rutaServe: `${API_URL}archivo/obtenerArchivo/`,
            visor: false,
            nombreComp: '',
            rv: false,
            ru: false,
            rm: false,
            opcs: false,
            valid: true,
            screen: false,
            fullWindows: false,
            value: '',

            indexDiapositiva: -1,
            idDiapositiva: -1,
            diapost: [],
            pregunta: [],

            tempImgCanvas: Object,
            cropping: false,
            imgTemp: '',
            imgBLOB: '',

            transitionName: "",
            transitionEfectos: ["fade", "fadeUp", "zoom", "slideUp"],

            jsonIN: {},
            jsonOUT: {},
            jsonEND: {},

        }
    },


    watch: {
        // activar o inactivar al modal 
        estadoModal() {

            if (this.estadoModal) {
                this.loadMain()
            } else {
                // this.parametros = {}
                // this.limpiarForm()                }
            }
        },

    },



    mounted() {
        this.loadMain()
    },

    methods: {

        ...mapMutations('mensajeSis', ['setEnviarMens']),

        async loadMain() {

            this.jsonIN = this.rutaServe
            this.fullWindows = false
            // alert(JSON.stringify(this.parametros))
            this.getData(this.parametros)
            this.openFullScreen()
        },

        async getData(item) {
            try {
                //console.log(` obtener datos para listar la clase ID: ${item.id_clase}` )
                const { success } = this.$states;
                await axios.get(`/manager/contenido/list/${item.id_clase}`)
                    .then(({ data }) => {
                        if (data.messageT == success && Object.keys(data.payload).length > 0) {
                            this.data = data.payload;
                            this.startDiapositiva(this.data)
                        } else {
                            this.data = []
                            this.setEnviarMens({ tipo: "W", mensaje: 'Aún no existen diapositivas creadas.', tiempo: 8000 })
                        }
                    })

            }
            catch (error) {
                console.log(error);
            }
        },


        async startDiapositiva(data) {
            //this.$refs.elementFocus.focus() // ref="elementFocus"
            let index = 0
            // this.loadDiapositiva(data[index], index)
            await this.crearMiniatura(data)

            if (this.parametros.guardarMiniatura) {
                // open in end miniatura
                index = (data.length - 1)
                console.log("Imprimir Index")
                console.log(index)

                const datosDiapositiva = data[index]
                await this.loadDiapositiva(datosDiapositiva, index)
                let vf = this // acceso a vue 
                setTimeout(function () {
                    vf.loadScreen('contenedorScreen')
                }, 1500);

            } else {
                this.loadDiapositiva(data[index], index)
            }


        },


        crearMiniatura(data) {

            if (this.parametros.miniatura) {

                console.log("Crear Miniatura")
                console.log("Total de regitros" + data.length)
                // this.parametros.id_diapositiva = 27190  // primera 
                // this.parametros.id_diapositiva = 43860

                for (const [key, value] of Object.entries(data)) {
                    // console.log(key, value, value.id)
                    if (value.id == this.parametros.id_diapositiva) {

                        this.loadDiapositiva(value, key)
                        this.loadScreen('contenedorScreen')

                    }
                }

            }

        },


        loadComponente(tipo) {

            let error = true
            if (tipo === 'C1') {
                this.nombreComp = 'VistaCol01'
                error = false

            }
            if (tipo === 'C2') {
                this.nombreComp = 'VistaCol02'
                error = false
            }
            if (tipo === 'C3') {

                this.nombreComp = 'VistaCol03'
                error = false
            }
            if (tipo === 'PU' || tipo === 'PM' || tipo === 'PV') {
                this.nombreComp = 'VistaPreg'
                error = false
            }

            return error

        },

        loadDiapositiva(item, index) {

            console.log("ITEMS:" + item)
            console.log("INDEX:" + index)

            if (this.indexDiapositiva != index) {

                this.nombreComp = null

                this.indexDiapositiva = index
                this.idDiapositiva = item

                //let element = item.id
                //const xx = this.$refs[element]

                // ancla para posicional el scroll
                // let elementAncla = `#${index-1}`;
                document.location.href = `#${index - 1}`;

                // $("html,body").animate({scrollTop: $(elementAncla).offset().top}, 3000);
                // Efectos Aleatorios 
                const random = Math.floor(Math.random() * this.transitionEfectos.length)
                this.transitionName = this.transitionEfectos[random]

                if (item.tipo === 'C1' || item.tipo === 'C2' || item.tipo === 'C3') {
                    this.getDiapositivaColumna(item)
                } else {
                    this.getDiapositivaPregunta(item)
                }

            } else {
                this.setEnviarMens({ tipo: "W", mensaje: `Ya estás en esta diapositiva.`, tiempo: null })
            }


        },


        async getDiapositivaColumna(item) {
            try {
                await axios.get(`/manager/contenido/${item.id}`)
                    .then(({ data }) => {
                        this.diapost = JSON.parse(data.payload.json_contenido)
                        this.rv = false
                        this.ru = false
                        this.screen = false
                        this.loadComponente(item.tipo)
                    })
                //console.log('dipost====>>>'+JSON.stringify(this.diapost.seccion1));
            } catch (error) {
                console.log(error);
            }

        },


        async getDiapositivaPregunta(item) {

            try {

                let response = await axios.get(`/manager/contenido/preg/${item.id}`);

                this.valid = true
                this.ru = false
                this.rm = false
                this.opcs = true
                this.pregunta = response.data.payload;
                this.screen = false
                this.loadComponente(item.tipo)
                //console.log('pregunta====>>>'+JSON.stringify(this.pregunta));
            } catch (error) {
                console.log(error)
            }

        },



        /*************************** */
        validarRespuesta(tipo) {
            if (tipo === 'prU') {
                this.ru = true
            } else if (tipo === 'prM') {
                this.rm = true
                this.opcs = false
                this.valid = false
            }

        },
        /******* cerrar modal y blanquear arreglos */
        cerrarModal() {

            this.$emit('close')
            this.closeFullScreen()

            // this.estadoModal = false
            this.indexDiapositiva = -1
            this.visor = false
            this.diapost = []
            this.pregunta = []

            this.nombreComp = ''
        },
        mostrarParticipacion() {
            this.$emit('mostrarParticipacion')
        },


        validarEventDiapositiva(event) {

            if (this.data.length > 0) {

                const maxIndex = this.data.length

                if (event == "next") {

                    let indexNew = this.indexDiapositiva + 1

                    if (indexNew < maxIndex) {
                        return indexNew
                    } else {
                        this.setEnviarMens({ tipo: "W", mensaje: `Fin de Diapositivas (${maxIndex})`, tiempo: null })
                        return false
                    }
                }
                if (event == "back") {
                    let indexNew = this.indexDiapositiva - 1
                    if (indexNew == -1) {
                        this.setEnviarMens({ tipo: "W", mensaje: `Ya esta en el inicio de la Diapositivas (1)`, tiempo: null })
                        return false
                    } else {
                        return indexNew
                    }

                }
                return false
            } else {
                return false
            }

        },


        eventDiapositiva(event) {

            const indexNew = this.validarEventDiapositiva(event)
            if (typeof (indexNew) == 'number') {
                const datosDiapositiva = this.data[indexNew]
                this.loadDiapositiva(datosDiapositiva, indexNew)
            }

        },


        openFullScreen() {

            var docElm = document.documentElement;
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
            }
            else if (docElm.msRequestFullscreen) {
                docElm = document.body; //overwrite the element (for IE)
                docElm.msRequestFullscreen();
            }
            else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen();
            }
            else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen();
            }

        },


        closeFullScreen() {

            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            }
            else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }

        },


        loadScreen(contScreen) {
            // actualiza la imagen preview del video
            this.screen = true
            let vf = this // acceso a vue 
            setTimeout(function () {
                vf.captureScreen(contScreen)
            }, 4000);
        },


        async captureScreen(contScreen) {

            let cont = this.$refs[contScreen]

            let configCanvas = {
                allowTaint: true,       // aceptar Imagenes
                useCORS: true          // permite exportar IMG
            }
            // crea un canvas temporal con el contenedor especificado
            await html2canvas(cont, configCanvas).then((temporalCanvas) => {

                console.log(temporalCanvas)
                // Captura solo para visualizar no sirve para mas nada..
                let img = canvas2Image.convertToPNG(temporalCanvas);
                this.imgTemp = img.src


                let vf = this

                // covierte el archivo de canvas a tipo BLOB para poder guardarlo
                temporalCanvas.toBlob(function (blob) {

                    setTimeout(function () {
                        vf.saveMiniatura(blob, vf.parametros)
                    }, 2500);
                });


            });

        },




        async saveMiniatura(archivo, parametros) {
            this.setEnviarMens({ tipo: "S", mensaje: `Guardar miniatura `, tiempo: null })
            // console.log(` Archivo Miniatura:  ${archivo}`)

            try {

                let formData = new FormData();
                formData.append('subirArchivo', archivo)

                formData.append("id_nivel", parametros.id_adm_nivel)
                formData.append("id_grado", parametros.id_grado)
                formData.append("id_area", parametros.id_adm_area)
                formData.append("id_tema", parametros.id_tema)
                formData.append("id_curso", parametros.id_curso)
                formData.append("id_clase", parametros.id_clase)


                let response = await axios.post('/archivo/miniaturaAdd', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                console.log(response.data)
                let res = response.data
                let vm = this
                setTimeout(function () {
                    vm.screen = false
                    vm.imgTemp = ""
                }, 3000);

                if (res.messageT == "S") {
                    this.saveItem(this.idDiapositiva, res)
                } else {
                    this.setEnviarMens({ tipo: res.messageT, mensaje: res.message, tiempo: 5000 })
                }

            }

            catch {
                this.setEnviarMens({ tipo: "E", mensaje: `Error en cargar archivo en el Servidor`, tiempo: 5000 })
                this.screen = false
                this.imgTemp = ""
                return false

            }

        },


        async saveItem(itemDiapositiva, datosMiniatura) {

            try {

                this.setEnviarMens({ tipo: "S", mensaje: `Actualizando miniatura`, tiempo: 5000 })
                console.log("Actualizar Contenido de Miniatura")
                this.jsonOUT = "ENTRO EN GUARDAR"

                let miniatura = {
                    id_usuario: sessionStorage.id,
                    miniatura_ruta: datosMiniatura.rutaDestino,
                    miniatura_archivo: datosMiniatura.nombreArchivo

                }

                this.jsonOUT = miniatura

                let response = await axios.put(`/manager/contenido/miniatura/${itemDiapositiva.id}`, miniatura);

                console.log(response.data)

            } catch (e) {
                console.log(e)
                this.setEnviarMens({ tipo: "E", mensaje: `Error en cargar archivo en el Servidor`, tiempo: 5000 })
                return false
            }

        },

    }
}
</script>




<style scoped>
.prueba01-enter-active,
.prueba01-leave-active {
    transition: opacity .5s
}

.prueba01-enter,
.prueba01-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0
}

.tituloDiapositiva {
    font-family: Arial, Helvetica, sans-serif;
    width: 100%;
    color: #1565C0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: 3px;
    margin-right: 3px;
}

.titulo-diapositiva {
    color: #1565C0;
    text-transform: uppercase;
}

.tu-clase {
    margin-left: 10px;
}

.classP {

    border-color: #ffbc00;
    border-width: 5px;
    border-style: ridge;

}

.canvas {
    border: 2px solid #d9d9d9;
}


.cardMiniatura {
    max-height: 200px;
    overflow: hidden;

}

.contenido_lienzo {

    background-color: whitesmoke;

}


.contMiniatura {
    width: 100%;
}


.avatar_num {
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 2;
}

.btn_zindex {
    position: absolute;
    right: 0px;

    z-index: 1;
    padding: 6px 0px 0px 0px;

}
</style>